import { useUserStore } from 'store/user';

import { useDasApiQuery } from 'lib/api/useApiQuery';

export const useDepositAddresses = () => {
  const { userRole } = useUserStore();
  const { data, error, isLoading, refetch } = useDasApiQuery(
    'deposit_addresses',
    {
      queryOptions: {
        refetchOnMount: false,
        retry: false,
        enabled: Boolean(userRole) && userRole !== 'ADMIN',
      },
    },
  );

  return {
    data,
    error,
    refetch,
    isLoading,
  };
};
